var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    _vm._b(
      {
        staticClass: "form-grid",
        style: { "padding-left": _vm.paddingLeft },
        attrs: { type: "flex" }
      },
      "el-row",
      {
        align: _vm.gridAlign,
        gutter: _vm.gridGutter,
        justify: _vm.gridJustify
      },
      false
    ),
    _vm._l(_vm.formNode.children, function(col, colIndex) {
      return _c(
        "el-col",
        {
          key: colIndex,
          staticClass: "form-grid_col",
          attrs: {
            span: _vm.formMap[col.id].baseOption.span
              ? _vm.formMap[col.id].baseOption.span
              : 0
          }
        },
        [
          _c(
            "draggable",
            {
              staticClass: "form-grid_draggable",
              attrs: {
                value: col.children,
                options: {
                  group: { name: "grid_wrap", put: _vm.onPut },
                  handle: ".drag-bar",
                  ghostClass: "draggable-status_ghost"
                }
              },
              on: {
                input: function(v) {
                  return (col.children = v.filter(function(i) {
                    return i
                  }))
                },
                add: function(e) {
                  return _vm.handleAddFormItem(e, col.children)
                }
              },
              model: {
                value: col.children,
                callback: function($$v) {
                  _vm.$set(col, "children", $$v)
                },
                expression: "col.children"
              }
            },
            _vm._l(col.children, function(el) {
              return _c("form-item-template", {
                key: el.id,
                class: el.type,
                attrs: { formNode: el, formParent: col.children }
              })
            }),
            1
          )
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39cfc064", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39cfc064","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form_item/FormItemGrid.vue
// module id = null
// module chunks = 